import { HttpContext } from '@adonisjs/core/http'
import { CherryPick, LucidModel, ModelQueryBuilderContract } from '@adonisjs/lucid/types/model'
import { StrictValues } from '@adonisjs/lucid/types/querybuilder'
import { DateTime } from 'luxon'
import InternalServerErrorException from '../exceptions/internal_server_error_exception.js'
import { ModelProps } from '../types.js'

type PaginateOptions = {
  context?: HttpContext
  maxPageSize?: number
}
/**
 * 模型分页
 * @example await paginate(model, (query) => query.where('id',id))
 */
export const paginate = <T extends LucidModel>(
  /** 模型 */
  model: T,
  queryCallback?: (query: ModelQueryBuilderContract<T>) => void,
  options?: PaginateOptions
) => {
  const { context, maxPageSize = 100 } = options || {}
  let pageSize = 10
  let current = 1
  /** e.g. {asc: 'sort} */
  let desc = 'id'
  let asc = 'id'
  let isDesc = true

  const ctx = context || HttpContext.get()
  if (!ctx) {
    throw new InternalServerErrorException()
  }
  const query = model.query()
  const qs = ctx.request.qs()

  if (qs.current) current = Number(qs.current || qs.page || 1)
  if (qs.pageSize) pageSize = Number(qs.pageSize || qs.size || 10)
  if (qs.descend) {
    desc = qs.descend
  } else if (qs.ascend) {
    asc = qs.ascend
    isDesc = false
  }
  if (qs.start_time && qs.end_time) {
    query.whereBetween('created_at', [qs.start_time, qs.end_time])
  }

  if (pageSize > maxPageSize) pageSize = maxPageSize
  if (current < 1) current = 1

  query.orderBy(isDesc ? desc : asc, isDesc ? 'desc' : 'asc')

  if (queryCallback) {
    queryCallback(query)
  }

  return query.paginate(current, pageSize)
}

/**
 * @example getBetweenDates(7)
 */
export const getBetweenDates = (day: number): [StrictValues, StrictValues] => {
  const now = DateTime.now()

  return [now.minus({ days: day }).toJSDate(), now.toJSDate()]
}

/**
 * @example batchSerialize(models)
 */
export const batchSerialize = <T extends InstanceType<LucidModel>>(
  models: T[],
  cherryPick?: CherryPick
) => {
  return models.map((model) => model.serialize(cherryPick)) as ModelProps<T>[]
}

/**
ts类型

static buidValidOrderQueryWhere<T extends LucidModel, U>(
    query: ModelQueryBuilderContract<T, U> | DatabaseQueryBuilderContract,
) {
  return query.where('paid', 1).whereNull('order_refund_id')
}


 */
